export default __webpack_public_path__ + "static/media/image-cushion-g-w@2x.b167c67b.webp";